import HomeIcon from '@mui/icons-material/Home';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HandshakeIcon from '@mui/icons-material/Handshake';

export const CUSTOMER_DESTINATION_TYPE_VALUES = ['home', 'store', 'branch'];

const DESTINATION_ICONS = {
  home: HomeIcon,
  store: StorefrontIcon,
  branch: HandshakeIcon,
};

/**
 * @param {string} value
 * @param {(key: string, opts?: object) => string} t
 * @param {string} [siteName]
 */
export function formatCustomerDestinationTypeLabel(value, t, siteName) {
  if (!value || typeof value !== 'string') return '—';
  const key = value.toLowerCase().trim();
  if (key === 'home') return t('customer.destinationHome');
  if (key === 'store') return t('customer.destinationStore', { site: siteName || '' });
  if (key === 'branch') return t('customer.destinationBranch');
  return value;
}

/**
 * @param {(key: string, opts?: object) => string} t
 * @param {string} siteName
 */
export function getCustomerDestinationTypeOptions(t, siteName) {
  return CUSTOMER_DESTINATION_TYPE_VALUES.map((value) => ({
    value,
    icon: DESTINATION_ICONS[value],
    title: t(`customer.deliveryDestination.${value}.title`, { site: siteName }),
    description: t(`customer.deliveryDestination.${value}.description`, { site: siteName }),
    hint: t(`customer.deliveryDestination.${value}.hint`, { site: siteName }),
    placeholder: t(`customer.deliveryDestination.${value}.placeholder`, { site: siteName }),
  }));
}

/**
 * @param {string} destinationType
 * @param {(key: string, opts?: object) => string} t
 * @param {string} siteName
 */
export function getCustomerDestinationPlaceholder(destinationType, t, siteName) {
  const key = String(destinationType || 'home').toLowerCase().trim();
  const safeKey = CUSTOMER_DESTINATION_TYPE_VALUES.includes(key) ? key : 'home';
  return t(`customer.deliveryDestination.${safeKey}.placeholder`, { site: siteName });
}
